export const adaptProjectSummaryRow = (transaction, { modelId, workDate } = {}) => {
    const resolvedTransaction = {
        ...transaction,
        ModelID: modelId ?? transaction.ModelID,
        WorkDate: workDate ?? transaction.WorkDate,
    };

    return {
        ID: transaction.ID,
        key: transaction.ID,
        TransactionID: transaction.ID,
        Transaction: resolvedTransaction,
        ModelID: resolvedTransaction.ModelID,
        WorkDate: resolvedTransaction.WorkDate,
        RefDate: transaction.RefDate,
        WorkDateCancelled: transaction.WorkDateCancelled,
        ClientStatements: transaction.ClientStatements || [],
        ModelStatements: transaction.ModelStatements || [],
        Family: transaction.Family,
        Currency: transaction.Currency,
        Quantity: transaction.Quantity,
        TypeQuantity: transaction.TypeQuantity,
        SingleFee: transaction.SingleFee,
        TotalFee: transaction.TotalFee,
        Description: transaction.Description,
        UsageID: transaction.UsageID,
        ClientBillingInfo: transaction.ClientBillingInfo,
        ExternalFee: transaction.ExternalFee,
    };
};

export const adaptProjectSummaryRows = (transactions = [], options = {}) => {
    return transactions.map((transaction) => adaptProjectSummaryRow(transaction, options));
};
